import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { CommunicationApiService } from "@api/communication/communication-api.service"
import { CSharpTypeMapper, DynamicVariableList, DynamicVariableResponse, InputValue, Properties } from "@api/communication/models/communication"
import { Function, FunctionInfo } from "@api/communication/models/functions"
import { Page } from "@api/communication/models/hotel-directory"
import { BetaFeatures } from "@api/utility/models/BetaFeatures"
import { UtilityApiService } from "@api/utility/utility-api.service"
import { LabelValue } from "@shared/animations/round-drop-down-list-v3"
import { Employee } from "@shared/models/employee"
import { IconImageService } from "@shared/services/icon-image.service"
import { StateService } from "@shared/services/state.service"
import { ToastServiceV2 } from "@shared/services/toast-v2/toast-v2.service"
import { TemplateService } from "app/communication/messages/template.service"
import { v4 as uuidv4 } from "uuid"

@Component({
  selector: "app-dynamic-variable-dialog",
  templateUrl: "./dynamic-variable-dialog.component.html",
  styleUrls: ["./dynamic-variable-dialog.component.scss"],
  standalone: false,
})
export class DynamicVariableDialogComponent implements OnInit {
  public searchText: string
  public dynamicVariableList: DynamicVariableResponse[]
  public categoryList: LabelValue[] = []
  public DynamicDataList: DynamicVariableResponse
  public propertiesList: Properties[] = []
  public filteredPropertiesList: Properties[] = []
  private availablePropertiesList: Properties[] = []
  public selectedDynamicVariable: Properties
  public selectedVariable: boolean = false
  public selectedOption: string = "Hide"
  public defaultValue: string = ""
  public listOfPages: Page[] = []
  public subPageOptions: LabelValue[] = []
  public selectedSubPage: LabelValue
  public hotelId: string
  private betaFeatures: BetaFeatures
  hideDialog: boolean = true

  @Input() communicationMode: boolean = true
  @Input() hotelDirectoryMode: boolean = false
  @Input() templateId: string = ""
  @Input() existingFunctions: DynamicVariableList[]
  @Input() height: string = "600px"
  @Output() toggleDialog = new EventEmitter<boolean>()
  @Output() savedFunctionInfo = new EventEmitter<FunctionInfo>()

  @HostListener("document:click", ["$event"])
  clickedOutside(event) {
    if (!this.eRef.nativeElement.contains(event.target) && !this.hideDialog) {
      this.hideDialog = true
      this.toggleDialog.emit(true)
    } else {
      this.hideDialog = false
    }
  }

  constructor(
    public utilityApiService: UtilityApiService,
    public toastService: ToastServiceV2,
    public communicationApiService: CommunicationApiService,
    public templateService: TemplateService,
    public stateService: StateService,
    private eRef: ElementRef,
    public iconService: IconImageService,
  ) {}

  ngOnInit(): void {
    this.hotelId = this.stateService.selectedHotel.Id
    var template = this.communicationMode && !this.hotelDirectoryMode ? this.templateService.getTemplate() : null
    const payByLink = template?.objective === "Pay by Link" ? true : false
    var user: Employee = JSON.parse(localStorage.getItem("user"))
    this.communicationApiService.Communication.GetDynamicVariableList(this.stateService.selectedHotel.Id, payByLink).subscribe((list) => {
      this.dynamicVariableList = list
      this.DynamicDataList = this.dynamicVariableList.find((x) => x.isRoot === true)
      this.findLowerLayer(this.dynamicVariableList)
      this.propertiesList.push({ context: "HotelDirectory", displayName: "Hotel Directory link", imageUrl: "https://aeroguestblobstorageprod.blob.core.windows.net/icons23/Other/Other/hotel_directory_link.svg", name: "HotelDirectoryLink", type: "String" })
      this.propertiesList.sort((a, b) => a.displayName.localeCompare(b.displayName))
      this.filteredPropertiesList = this.propertiesList
      const hiddenExtrasLink = this.hotelDirectoryMode ? "ExtrasLinkSms" : "ExtrasLinkHotelDirectory"
      this.filteredPropertiesList = this.filteredPropertiesList.filter((x) => x.name !== "RatePlanCode" && x.name !== "Comments" && x.name !== hiddenExtrasLink)
      if (template?.templateType === "EMAIL" && this.communicationMode) {
        this.filteredPropertiesList = this.filteredPropertiesList.filter((x) => x.name !== "CheckinLinkSMS" && x.name !== "CheckinLink" && x.name !== "Check in Link" && x.name !== "CheckoutLinkSMS" && x.name !== "CheckoutLink" && x.name !== "Check out Link" && x.name !== "ExtrasLinkSms")
      } else if (this.communicationMode) {
        this.filteredPropertiesList = this.filteredPropertiesList.filter((x) => x.name !== "CheckinLinkEmail" && x.name !== "CheckinLink" && x.name !== "Check in Link" && x.name !== "CheckoutLinkEmail" && x.name !== "CheckoutLink" && x.name !== "Check out Link" && x.name !== "ExtrasLinkEmail")
      }
      var topLevelNodes: string[] = []
      list.forEach((node) => {
        topLevelNodes.push(node.typeName)
      })
      this.filteredPropertiesList = this.filteredPropertiesList.filter((x) => !topLevelNodes.includes(x.type))
      this.availablePropertiesList = this.filteredPropertiesList
      this.utilityApiService.V1BetaFeatures.getFeatures(this.hotelId).subscribe((features) => {
        this.betaFeatures = features
        if (!this.betaFeatures.features["Extras"]) {
          const isExtrasLink = (x: Properties): boolean => x.name === "ExtrasLink" || x.name === "ExtrasLinkEmail" || x.name === "ExtrasLinkSms" || x.name === "ExtrasLinkHotelDirectory"
          this.availablePropertiesList = this.availablePropertiesList.filter((x) => !isExtrasLink(x))
          this.filteredPropertiesList = this.filteredPropertiesList.filter((x) => !isExtrasLink(x))
        }
      })
    })

    this.communicationApiService.HotelDirectory.getAllDirectory(user?.OrganizationId, this.hotelId).subscribe((x) => {
      var listOfDirectorys = x
      var liveHotelDirectory = listOfDirectorys.find((x) => x.status === "Live")
      this.communicationApiService.HotelDirectory.getAllContent(this.hotelId, liveHotelDirectory.id).subscribe((pages) => {
        this.listOfPages = pages
        this.listOfPages.forEach((page) => {
          this.subPageOptions.push({ label: page.name, value: page.pageId })
        })
        this.selectedSubPage = this.subPageOptions.find((x) => x.value === liveHotelDirectory.id)
      })
    })
    this.hideDialog = true
  }
  private findLowerLayer(dynamicVariableList: DynamicVariableResponse[]) {
    dynamicVariableList.forEach((dv) => {
      if (dv.isRoot === true) {
        dv.properties.forEach((variable) => {
          if (dv.typeName !== variable.name) {
            variable.context = "None"
            this.propertiesList.push(variable)
          }
        })
      }

      if (dv.properties.length > 0 && !dv.isRoot && this.DynamicDataList.properties.find((x) => x.type === dv.typeName)) {
        dv.properties.forEach((variable) => {
          const dvPrefix = this.DynamicDataList.properties.find((x) => x.type === dv.typeName).name
          variable.context = dvPrefix
          if (this.dynamicVariableList.find((x) => x.typeName === variable.type)) {
            var list = this.dynamicVariableList.find((x) => x.typeName === variable.type)
            var subdvName = dv.properties.find((x) => x.type === list.typeName).name
            list.properties.forEach((listvar) => {
              listvar.context = dvPrefix + ":" + subdvName
            })
            this.propertiesList = [...this.propertiesList, ...list.properties]
          } else {
            this.propertiesList.push(variable)
          }
        })
      }
    })
  }
  public closeDialog(event: Event): void {
    event.stopPropagation()
    this.hideDialog = true
    this.toggleDialog.emit(true)
  }

  public cancelDialog(): void {
    this.hideDialog = true
    this.toggleDialog.emit(true)
  }

  public insertDynamicVariable(): void {
    if (this.selectedDynamicVariable.name === "HotelDirectoryLink") {
      this.buildHotelDirectoryLink()
      return
    }
    var chosenString: object = null
    var chosenFallback: object = null

    const dvPrefix = this.selectedDynamicVariable.context
    const dvName = dvPrefix === "None" ? this.selectedDynamicVariable.name : dvPrefix + ":" + this.selectedDynamicVariable.name

    if (this.selectedDynamicVariable.type === "IList<String>") {
      var list = {
        BodyDataType: null,
        BodyType: "dv",
        BodyData: dvName,
        ChildBodies: [],
      }
      var listToString = {
        BodyData: "listOfTextToText",
        BodyDataType: null,
        BodyType: "f",
        ChildBodies: [
          list,
          {
            BodyDataType: "String",
            BodyType: "sv",
            BodyData: "<br>",
            ChildBodies: [],
          },
        ],
      }
      var fallBack = {
        BodyData: "variableWithStringFallback",
        BodyDataType: null,
        BodyType: "f",
        ChildBodies: [
          datetimeToString,
          {
            BodyDataType: "String",
            BodyType: "sv",
            BodyData: this.defaultValue,
            ChildBodies: [],
          },
        ],
      }
      chosenString = listToString
      chosenFallback = fallBack
    } else if (this.selectedDynamicVariable.name === "StartDate" || this.selectedDynamicVariable.name === "EndDate") {
      var date = {
        BodyDataType: null,
        BodyType: "dv",
        BodyData: dvName,
        ChildBodies: [],
      }
      var datetimeToString = {
        BodyData: "dateTimeToString",
        BodyDataType: null,
        BodyType: "f",
        ChildBodies: [
          date,
          {
            BodyDataType: "String",
            BodyType: "sv",
            BodyData: "MMM. dd, yyyy",
            ChildBodies: [],
          },
        ],
      }
      var fallBackWrapper = {
        BodyData: "variableWithStringFallback",
        BodyDataType: null,
        BodyType: "f",
        ChildBodies: [
          datetimeToString,
          {
            BodyDataType: "String",
            BodyType: "sv",
            BodyData: this.defaultValue,
            ChildBodies: [],
          },
        ],
      }
      chosenString = datetimeToString
      chosenFallback = fallBackWrapper
    } else {
      var dynamicVariable = {
        BodyDataType: null,
        BodyType: "dv",
        BodyData: dvName,
        ChildBodies: [],
      }

      var bodyFallback = {
        BodyData: "variableWithStringFallback",
        BodyDataType: null,
        BodyType: "f",
        ChildBodies: [
          dynamicVariable,
          {
            BodyDataType: "String",
            BodyType: "sv",
            BodyData: this.defaultValue,
            ChildBodies: [],
          },
        ],
      }
      chosenString = dynamicVariable
      chosenFallback = bodyFallback
    }

    var func: Function = {
      hotelId: this.stateService.selectedHotel.Id,
      rootId: this.templateId,
      id: uuidv4(),
      description: "",
      name: this.selectedDynamicVariable.name,
      _body: this.selectedOption === "Hide" ? JSON.stringify(chosenString) : JSON.stringify(chosenFallback),
    }
    this.saveFunction(func)
  }
  public buildHotelDirectoryLink(): void {
    var pageAlias = this.listOfPages.find((x) => x.pageId === this.selectedSubPage.value)?.alias ?? ""
    pageAlias = pageAlias.replace("_", "/")
    var chosenString = {
      BodyData: "hotelDirectoryLink",
      BodyDataType: null,
      BodyType: "f",
      ChildBodies: [
        {
          BodyDataType: "String",
          BodyType: "sv",
          BodyData: pageAlias,
          ChildBodies: [],
        },
        {
          BodyDataType: null,
          BodyType: "dv",
          BodyData: "Reservation:PersonalTag",
          ChildBodies: [],
        },
      ],
    }

    var func: Function = {
      hotelId: this.stateService.selectedHotel.Id,
      rootId: this.templateId,
      id: uuidv4(),
      description: "",
      name: this.selectedDynamicVariable.name,
      _body: JSON.stringify(chosenString),
    }
    this.saveFunction(func)
  }

  private getFunctionName(): string {
    if (this.selectedOption === "Hide") return this.selectedDynamicVariable.displayName
    return this.selectedDynamicVariable.displayName + " or " + this.defaultValue
  }

  private emitSavedFunction(functionId: string, functionName: string): void {
    this.savedFunctionInfo.emit({ functionId: functionId, functionName: functionName, imageUrl: this.selectedDynamicVariable.imageUrl })
    this.hideDialog = true
    this.toggleDialog.emit(true)
  }

  private saveFunction(func: Function): void {
    const functionName = this.getFunctionName()
    const existing = this.existingFunctions?.find((x) => x.placeholder === `[${functionName}]`)
    if (existing) {
      this.emitSavedFunction(existing.functionId, functionName)
      return
    }
    this.communicationApiService.Function.SaveFunction(func).subscribe(
      (x) => {
        this.emitSavedFunction(func.id, functionName)
      },
      (error) => {
        console.log(error)
        this.toastService.error({ title: "Couldn't add personalised tag", message: "The tag could not be saved. Please try again or contact AeroGuest support." })
      },
    )
  }

  changedSubPage(subPage: LabelValue) {
    this.selectedSubPage = subPage
  }

  public onSearchChange(target: EventTarget | null): void {
    const search = (target as HTMLInputElement).value.toLocaleLowerCase()
    this.filteredPropertiesList = this.availablePropertiesList.filter((x) => x.displayName.toLocaleLowerCase().includes(search))
  }

  public changeDefaultValue(event: any): void {
    this.defaultValue = event.value
  }
  public selectVariable(property: Properties): void {
    this.selectedVariable = true
    this.selectedDynamicVariable = property
  }

  public insertClickable(): boolean {
    if (this.selectedOption) {
      if (this.selectedOption === "Fallback" && !this.defaultValue) return false
      return true
    }
    return false
  }
}
